import React from "react";
import NavigationItem from "./NavigationItem";
import NavigationData from "./navigation-data/nav";
import { NavigationItems } from "../interfaces/Navigation";
import { useSelector } from "react-redux";
import { RootState } from "../store/rootReducer";
import NavigationUser from "./NavigationUser";

export const Navigation = () => {
  const systemAccess =  useSelector((state: RootState) => state.authorization.systemAccess);

  const allowMenuDisplay = (permissionId: string) => {
    return systemAccess[permissionId].ACCESS.read;
  }

  const renderNavigationItems = (data: NavigationItems[]) => {
    return data.map((item, index) => {
      if (allowMenuDisplay(item.permissionId)) {
        return (
          <NavigationItem
            key={index}
            title={item.title}
            route={item.route}
            icon={item.icon}
          />
        );
      } else {
        return null;
      }
    });
  }

  const renderNavigation = () => {
    return NavigationData.map((item, index) => {
      const navigationItems = renderNavigationItems(item.items).filter(item => item !== null);
      
      if (navigationItems.length > 0)
        return (
          <React.Fragment key={index}>
            <li className="header">{item.title}</li>
            { navigationItems }
          </React.Fragment>
        );
      return null;
    });
  }

  return (
    <aside className="main-sidebar">
      <section className="sidebar">
        <NavigationUser />
        <ul className="sidebar-menu" data-widget="tree">
          { renderNavigation() }
        </ul>
      </section>
    </aside>
  );
};
